import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Moment } from 'moment';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { CreatePlanDialogComponent } from 'src/app/dialogs/create-plan-dialog/create-plan-dialog.component';
import { Paginator } from 'src/app/models/paginator';
import { Plan } from 'src/app/models/plan';
import { Role } from 'src/app/models/user';
import { AdminService } from 'src/app/services/admin.service';
import { MessageService } from 'src/app/services/message.service';
import { PlanService } from 'src/app/services/plan.service';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class PlansComponent {

  loading: boolean = false;
  done: boolean = false;
  /** The last load failed: the list says so instead of claiming there is no plan. */
  failed: boolean = false;
  noDocs: boolean = false;
  plans: Paginator<Plan> = {
    docs: [],
    page: 1,
    offset: 0,
    limit: 10,
    totalDocs: 0,
    sort: 'label'
  };
  filteredPlans: Plan[] = [];
  displayedColumns: string[] = ['label', 'type', 'maxVolume', 'maxTrademarks', 'maxCases', 'maxCrawlerUrl', 'annualPrice', 'actions'];
  dataSource: MatTableDataSource<Plan> = new MatTableDataSource<Plan>([])

  query?: string;

  public role = Role;

  constructor(
    private _message: MessageService,
    private dialog: MatDialog,
    private planService: PlanService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.done = false;
    await this.retrievePlans(true);
    this.loading = false;
    this.done = true;
    // this.filtersSubscription = this.filtersSubject
    //   .pipe(
    //     debounceTime(300),
    //     distinctUntilChanged()
    //   ).subscribe(async () => {
    //     this.resetPage();
    //     await this.retrieveTrademarks(false);
    //   });
  }

  async retrievePlans(init: boolean) {
    try {
      this._message.emitChange("LOADING", "START");
      this.failed = false;

      this.plans ={ ...this.plans, ...await this.planService.retrievePlans(this.plans.page, this.plans.limit, this.plans.offset, this.plans.sort, this.query) };
      this.filteredPlans = this.plans.docs;

      this.dataSource = new MatTableDataSource<Plan>(this.filteredPlans);

      if (init && this.plans.totalDocs === 0) {
        this.noDocs = true;
      } else if (init && this.plans.totalDocs > 0) {
        this.noDocs = false;
      }

      this._message.emitChange("LOADING", "END");
    } catch (err) {
      this.failed = true;
      this._message.emitChange("LOADING", "END");
      this.toastr.error(`ERRORS.GENERIC`)
    }
  }



  onSortChange(event: any) {
    if (['asc', 'desc'].includes(event.direction)) {
      this.plans.sort = `${event.direction === 'desc' ? '-' : ''}${event.active}`;
      this.retrievePlans(false);
    }
  }

  async handlePage(event: PageEvent) {
    this.plans.limit = event.pageSize;
    this.plans.page = event.pageIndex + 1;
    this.plans.offset = event.pageIndex * this.plans.limit;
    this.retrievePlans(false);
  }

  formatDate(date: Moment) {
    return moment(date).format('ll');
  }

  async createPlan() {
    const config: MatDialogConfig = {
      panelClass: 'dialog-container',
      width: '480px',
      data: {}
    }
    const dialog = this.dialog.open(CreatePlanDialogComponent, config);
    const result: { created: boolean, plan?: Plan } = await firstValueFrom(dialog.afterClosed());
    if (result && result.created && result.plan) {
      try {
        this._message.emitChange("LOADING", "START");
        await this.planService.createPlan(result.plan);
        this._message.emitChange("LOADING", "END");
        this.toastr.success(this.translate.instant('ADMIN.PLAN_CREATED', { label: result.plan.label }));
        this.retrievePlans(true);
      } catch (err) {
        this.loading = false;
        this._message.emitChange("LOADING", "END");
        this.toastr.error('ERRORS.GENERIC');
      }
    }
  }
  async editPlan(plan: Plan) {
    const config: MatDialogConfig = {
      panelClass: 'dialog-container',
      width: '480px',
      data: { plan }
    }
    const dialog = this.dialog.open(CreatePlanDialogComponent, config);
    const result: { updated: boolean, plan?: Plan } = await firstValueFrom(dialog.afterClosed());
    if (result && result.updated && result.plan && plan._id) {
      try {
        this._message.emitChange("LOADING", "START");
        await this.planService.updatePlan(plan._id, result.plan);
        this._message.emitChange("LOADING", "END");
        this.toastr.success(this.translate.instant('ADMIN.PLAN_UPDATED', { label: result.plan.label }));
        this.retrievePlans(true);
      } catch (err) {
        this.loading = false;
        this._message.emitChange("LOADING", "END");
        this.toastr.error('ERRORS.GENERIC');
      }
    }
  }
}
